"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3a.7.7 0 0 1 .633.4l.987 2.083a.7.7 0 1 1-1.265.6L10 5.334 8.658 8.166a.7.7 0 0 1-.541.394l-2.987.395 1.388 1.502a.7.7 0 0 1-1.029.95L3.186 8.912a.7.7 0 0 1 .422-1.168l3.948-.522L9.367 3.4A.7.7 0 0 1 10 3Zm4.525 5.203a.7.7 0 0 1 .785-.602l1.082.143a.7.7 0 0 1 .422 1.168l-2.833 3.069.782 4.19a.7.7 0 0 1-1.003.754L10 15.035l-2.741 1.378a.7.7 0 1 1-.63-1.25l3.056-1.538a.7.7 0 0 1 .63 0l2.813 1.415-.588-3.148a.7.7 0 0 1 .174-.603l2.188-2.37a.7.7 0 0 1-.377-.716Zm2.22-4.948a.7.7 0 0 1 0 .99l-12.5 12.5a.7.7 0 0 1-.99-.99l12.5-12.5a.7.7 0 0 1 .99 0Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=NoStarIcon20.js.map